"use strict";
// Ops-related constants that need to be shared across backend + clients/tests.
// Keep this file small and stable; changes here fan out widely via translate tooling.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETOOL_EXTERNAL_IP = void 0;
exports.RETOOL_EXTERNAL_IP = '3.22.203.125';
